
      const logs = {
  "logsBelong": "Относится к",
  "recorder": "Рекордер",
  "logType": "Тип журнала",
  "loginType": "Платформа",
  "content": "Содержимое",
  "export": "Экспорт",
  "details": "Детали"
}
      export default logs
    